module.exports = __webpack_public_path__ + "static/media/comviva.efcf45f6.jpeg";